import React from 'react';

import { SVGComponentProps } from './svg.types';

const UnderlineSVG = ({
  fill = 'currentColor',
  size = '1em',
  wrapperClass,
  ...otherSvgProps
}: SVGComponentProps): JSX.Element => {
  return (
    <span className={`inline-block ${wrapperClass || ''}`}>
      <svg
        width={size}
        height={size}
        viewBox="0 0 14 14"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...otherSvgProps}
      >
        <path
          d="M6.88394 10.094C8.24693 10.0924 9.55365 9.55026 10.5174 8.58648C11.4812 7.6227 12.0234 6.31599 12.0249 4.953V1.205C12.0249 0.885414 11.898 0.578918 11.672 0.352936C11.446 0.126955 11.1395 0 10.8199 0C10.5004 0 10.1939 0.126955 9.96788 0.352936C9.7419 0.578918 9.61494 0.885414 9.61494 1.205V4.953C9.61494 5.67731 9.32721 6.37195 8.81505 6.88411C8.30289 7.39627 7.60825 7.684 6.88394 7.684C6.15964 7.684 5.465 7.39627 4.95283 6.88411C4.44067 6.37195 4.15294 5.67731 4.15294 4.953V1.205C4.14391 0.891292 4.01294 0.593463 3.78785 0.374763C3.56276 0.156064 3.26128 0.0337239 2.94744 0.0337239C2.63361 0.0337239 2.33213 0.156064 2.10704 0.374763C1.88195 0.593463 1.75098 0.891292 1.74194 1.205V4.953C1.74353 6.31616 2.28582 7.62303 3.24982 8.58683C4.21381 9.55064 5.52078 10.0927 6.88394 10.094Z"
          fill={fill}
        />
        <path
          d="M12.989 11.5811H1.011C0.745078 11.5821 0.490176 11.6874 0.301113 11.8744C0.11205 12.0614 0.00392846 12.3152 4.94605e-07 12.5811V12.9881C-0.000130911 13.1209 0.0259224 13.2525 0.0766711 13.3753C0.12742 13.498 0.201869 13.6096 0.295762 13.7036C0.389655 13.7976 0.501151 13.8721 0.623876 13.923C0.746602 13.9739 0.87815 14.0001 1.011 14.0001H12.989C13.2568 14.0001 13.5136 13.8938 13.7032 13.7046C13.8927 13.5155 13.9995 13.2588 14 12.9911V12.5831C13.9966 12.3168 13.8887 12.0626 13.6996 11.8751C13.5105 11.6877 13.2553 11.5821 12.989 11.5811Z"
          fill={fill}
        />
      </svg>
    </span>
  );
};

export default UnderlineSVG;
